export var getAssetSrc = function getAssetSrc(assetPath) {
  return process.env['NEXT_PUBLIC_VERCEL_URL'] ? "https://".concat(process.env['NEXT_PUBLIC_VERCEL_URL']).concat(assetPath) : assetPath;
};